module.exports = __webpack_public_path__ + "img/zfcg_08.510a4de1.png";